function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { colors, spacing, shadows, typography } from '../tokens';

/**
 * AppShell — sticky header + flex-column page shell.
 *
 * Props:
 *   logo        — ReactNode rendered left of brandTitle
 *   brandTitle  — string brand name shown in header
 *   navLinks    — Array<{ label, href, active, onClick? }>
 *   user        — { username?, email? } | null
 *   onLogout    — () => void
 *   renderLink  — (link, style) => ReactNode
 *                 Consumer provides the Link component (e.g. react-router <Link>).
 *                 Falls back to plain <a href> when omitted.
 *   children    — page content; laid out in a flex-grow <main>
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AppShell(_ref) {
  var _user$attributes, _user$attributes2;
  var logo = _ref.logo,
    _ref$brandTitle = _ref.brandTitle,
    brandTitle = _ref$brandTitle === void 0 ? 'Bafkal Portal' : _ref$brandTitle,
    _ref$navLinks = _ref.navLinks,
    navLinks = _ref$navLinks === void 0 ? [] : _ref$navLinks,
    user = _ref.user,
    onLogout = _ref.onLogout,
    renderLink = _ref.renderLink,
    footer = _ref.footer,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobileMenuOpen = _useState2[0],
    setIsMobileMenuOpen = _useState2[1];
  var headerStyle = {
    fontFamily: typography.fontFamily,
    backgroundColor: 'var(--bafkal-bg-surface)',
    borderBottom: "1px solid ".concat(colors.neutral[200]),
    boxShadow: shadows.sm,
    position: 'sticky',
    top: 0,
    zIndex: 50
  };
  var desktopNavLinkStyle = function desktopNavLinkStyle(active) {
    return {
      padding: "".concat(spacing.xs, " ").concat(spacing.xs, " 0"),
      color: active ? colors.neutral[900] : colors.neutral[500],
      fontWeight: 500,
      textDecoration: 'none',
      borderBottom: active ? "2px solid ".concat(colors.primary[500]) : '2px solid transparent',
      fontSize: typography.sizes.sm,
      display: 'inline-flex',
      alignItems: 'center',
      height: '64px',
      boxSizing: 'border-box',
      transition: 'color 0.15s ease-in-out, border-color 0.15s ease-in-out'
    };
  };
  var mobileNavLinkStyle = function mobileNavLinkStyle(active) {
    return {
      display: 'block',
      padding: "".concat(spacing.sm, " ").concat(spacing.md),
      borderRadius: '6px',
      fontSize: typography.sizes.sm,
      fontWeight: active ? 600 : 400,
      textDecoration: 'none',
      color: active ? colors.primary[600] : colors.neutral[700],
      backgroundColor: active ? colors.primary[50] : 'transparent'
    };
  };
  var _renderLink = function _renderLink(link, style) {
    if (renderLink) {
      return renderLink(link, style);
    }
    return /*#__PURE__*/_jsx("a", {
      href: link.href,
      style: style,
      onClick: link.onClick,
      children: link.label
    }, link.href || link.label);
  };
  var closeMobileMenu = function closeMobileMenu() {
    return setIsMobileMenuOpen(false);
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      minHeight: '100vh',
      backgroundColor: colors.neutral[50],
      display: 'flex',
      flexDirection: 'column'
    },
    children: [/*#__PURE__*/_jsx("style", {
      children: "\n        .bafkal-desktop-nav { display: flex; gap: ".concat(spacing.xl, "; height: 100%; }\n        .bafkal-hamburger   { display: none; background: none; border: none; cursor: pointer; padding: ").concat(spacing.xs, "; }\n        @media (max-width: 640px) {\n          .bafkal-desktop-nav { display: none; }\n          .bafkal-hamburger   { display: flex; align-items: center; justify-content: center; }\n        }\n      ")
    }), /*#__PURE__*/_jsxs("header", {
      style: headerStyle,
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          maxWidth: '1280px',
          margin: '0 auto',
          padding: "0 ".concat(spacing.lg),
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '64px'
        },
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: spacing.lg
          },
          children: [/*#__PURE__*/_jsxs("div", {
            style: {
              display: 'flex',
              alignItems: 'center',
              gap: spacing.sm,
              fontWeight: 700,
              fontSize: typography.sizes.lg,
              color: colors.neutral[900]
            },
            children: [logo, /*#__PURE__*/_jsx("span", {
              children: brandTitle
            })]
          }), /*#__PURE__*/_jsx("nav", {
            className: "bafkal-desktop-nav",
            children: navLinks.map(function (link) {
              return _renderLink(link, desktopNavLinkStyle(link.active));
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: spacing.md
          },
          children: [user && /*#__PURE__*/_jsx("span", {
            style: {
              fontSize: typography.sizes.sm,
              color: colors.neutral[700]
            },
            children: user.username || ((_user$attributes = user.attributes) === null || _user$attributes === void 0 ? void 0 : _user$attributes.email) || user.email
          }), onLogout && /*#__PURE__*/_jsx("button", {
            onClick: onLogout,
            style: {
              backgroundColor: colors.danger[600],
              color: 'var(--bafkal-bg-surface)',
              border: 'none',
              borderRadius: '4px',
              padding: "4px 12px",
              fontSize: typography.sizes.sm,
              cursor: 'pointer',
              fontFamily: typography.fontFamily
            },
            children: "Logout"
          }), /*#__PURE__*/_jsx("button", {
            className: "bafkal-hamburger",
            onClick: function onClick() {
              return setIsMobileMenuOpen(function (o) {
                return !o;
              });
            },
            "aria-label": "Toggle navigation menu",
            "aria-expanded": isMobileMenuOpen,
            children: /*#__PURE__*/_jsx("svg", {
              width: "24",
              height: "24",
              fill: "none",
              stroke: colors.neutral[500],
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: isMobileMenuOpen ? /*#__PURE__*/_jsx("path", {
                d: "M6 18L18 6M6 6l12 12"
              }) : /*#__PURE__*/_jsx("path", {
                d: "M4 6h16M4 12h16M4 18h16"
              })
            })
          })]
        })]
      }), isMobileMenuOpen && /*#__PURE__*/_jsxs("div", {
        style: {
          borderTop: "1px solid ".concat(colors.neutral[200]),
          backgroundColor: 'var(--bafkal-bg-surface)',
          padding: "".concat(spacing.sm, " ").concat(spacing.lg, " ").concat(spacing.md)
        },
        children: [/*#__PURE__*/_jsx("nav", {
          style: {
            display: 'flex',
            flexDirection: 'column',
            gap: spacing.xs
          },
          children: navLinks.map(function (link) {
            return _renderLink(_objectSpread(_objectSpread({}, link), {}, {
              onClick: function onClick() {
                var _link$onClick;
                closeMobileMenu();
                (_link$onClick = link.onClick) === null || _link$onClick === void 0 || _link$onClick.call(link);
              }
            }), mobileNavLinkStyle(link.active));
          })
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            marginTop: spacing.md,
            paddingTop: spacing.sm,
            borderTop: "1px solid ".concat(colors.neutral[200])
          },
          children: [user && /*#__PURE__*/_jsx("div", {
            style: {
              fontSize: typography.sizes.sm,
              fontWeight: 600,
              color: colors.neutral[700],
              marginBottom: spacing.xs
            },
            children: user.username || ((_user$attributes2 = user.attributes) === null || _user$attributes2 === void 0 ? void 0 : _user$attributes2.email) || user.email
          }), onLogout && /*#__PURE__*/_jsx("button", {
            onClick: function onClick() {
              closeMobileMenu();
              onLogout();
            },
            style: {
              background: 'none',
              border: 'none',
              padding: 0,
              fontSize: typography.sizes.sm,
              color: colors.danger[500],
              cursor: 'pointer',
              fontWeight: 500,
              fontFamily: typography.fontFamily
            },
            children: "Sign out"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("main", {
      style: {
        flexGrow: 1
      },
      children: children
    }), footer]
  });
}